export const CompetenceData = [
    {
        "id": 1,
        "nom": "FrontEnd" ,
        "outils": "Html CSS JS React R shiny Django Wagtail git github Streamlit Flask"
    },
    {
        "id": 2,
        "nom": "BackEnd" ,
        "outils": "Node Express Sequelize SQL postgreSQL MySQL"
    },
    {
        "id": 3,
        "nom": "Statistique" ,
        "outils": "R Shiny Rstudio Python Pandas"
    },
    {
        "id": 4,
        "nom": "Geomatique" ,
        "outils": "R Leaflet QGIS ArcGis OSM Geoportail Earthdata & divers MapMaker"
    },
    {
        "id": 5,
        "nom": "Langues" ,
        "outils": "Anglais C1 italien B1 espagnol B1 notion de chinois, breton et russe"
    },
]
